// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. Semaglutide + B6 Refill 09.17.26" (999fd97e-6aad-46a5-a897-d9a1ce8532ea). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiSemaglutideB6RefillAnswerField } from './questions';

export const mdiSemaglutideB6Refill: FormType<mdiSemaglutideB6RefillAnswerField> =
  {
    name: 'Semaglutide + B6 Refill',
    validityLength: 25,
    questions: [
      {
        key: 'mdiSemaglutideB6Refill_state',
        next: {
          switch: [
            {
              condition: { 'mdiSemaglutideB6Refill_state.la': true },
              key: 'mdiSemaglutideB6Refill_considerTreatmentGlp1AppropriateReasons'
            },
            {
              condition: { 'mdiSemaglutideB6Refill_state.ms': true },
              key: 'mdiSemaglutideB6Refill_considerTreatmentGlp1AppropriateReasons'
            }
          ],
          els: 'mdiSemaglutideB6Refill_overPast4WeeksApproximately'
        }
      },
      'mdiSemaglutideB6Refill_considerTreatmentGlp1AppropriateReasons',
      {
        key: 'mdiSemaglutideB6Refill_overPast4WeeksApproximately',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Refill_overPast4WeeksApproximately.im_gaining_weight':
                  true
              },
              key: 'mdiSemaglutideB6Refill_stillGainingWeight'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_overPast4WeeksApproximately.more_than_20_pounds':
                  true
              },
              key: 'mdiSemaglutideB6Refill_youreHavingSignificantAmountWeight'
            }
          ],
          els: 'mdiSemaglutideB6Refill_havingFoodCravings'
        }
      },
      {
        key: 'mdiSemaglutideB6Refill_stillGainingWeight',
        next: {
          condition: {
            'mdiSemaglutideB6Refill_overPast4WeeksApproximately.more_than_20_pounds':
              true
          },
          key: 'mdiSemaglutideB6Refill_youreHavingSignificantAmountWeight',
          els: 'mdiSemaglutideB6Refill_havingFoodCravings'
        }
      },
      'mdiSemaglutideB6Refill_youreHavingSignificantAmountWeight',
      'mdiSemaglutideB6Refill_havingFoodCravings',
      'mdiSemaglutideB6Refill_havingAppetiteSuppression',
      {
        key: 'mdiSemaglutideB6Refill_newChangesAdditionsMedicalHistory',
        next: {
          condition: {
            'mdiSemaglutideB6Refill_newChangesAdditionsMedicalHistory.yes_i_do':
              true
          },
          key: 'mdiSemaglutideB6Refill_tellDoctorAboutNewMedical',
          els: 'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects'
        }
      },
      'mdiSemaglutideB6Refill_tellDoctorAboutNewMedical',
      'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects',
      {
        key: 'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.having_side_effects_but_i_can_handle_the':
                  true
              },
              key: 'mdiSemaglutideB6Refill_makeSureLetDoctorPcp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.significant_vomiting':
                  true
              },
              key: 'mdiSemaglutideB6Refill_vomitingWhileTakingGlp1'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.abdominal_pain_that_concerns_me':
                  true
              },
              key: 'mdiSemaglutideB6Refill_abdominalPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.dizziness_that_concerns_me':
                  true
              },
              key: 'mdiSemaglutideB6Refill_dizzinessWhileTakingGlp1'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.chest_pain':
                  true
              },
              key: 'mdiSemaglutideB6Refill_chestPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.fevers':
                  true
              },
              key: 'mdiSemaglutideB6Refill_feverWhileTakingGlp1'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiSemaglutideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiSemaglutideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiSemaglutideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiSemaglutideB6Refill_constipation'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiSemaglutideB6Refill_heartburn'
            }
          ],
          els: 'mdiSemaglutideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiSemaglutideB6Refill_makeSureLetDoctorPcp',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.significant_vomiting':
                  true
              },
              key: 'mdiSemaglutideB6Refill_vomitingWhileTakingGlp1'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.abdominal_pain_that_concerns_me':
                  true
              },
              key: 'mdiSemaglutideB6Refill_abdominalPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.dizziness_that_concerns_me':
                  true
              },
              key: 'mdiSemaglutideB6Refill_dizzinessWhileTakingGlp1'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.chest_pain':
                  true
              },
              key: 'mdiSemaglutideB6Refill_chestPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.fevers':
                  true
              },
              key: 'mdiSemaglutideB6Refill_feverWhileTakingGlp1'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiSemaglutideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiSemaglutideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiSemaglutideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiSemaglutideB6Refill_constipation'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiSemaglutideB6Refill_heartburn'
            }
          ],
          els: 'mdiSemaglutideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiSemaglutideB6Refill_vomitingWhileTakingGlp1',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.abdominal_pain_that_concerns_me':
                  true
              },
              key: 'mdiSemaglutideB6Refill_abdominalPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.dizziness_that_concerns_me':
                  true
              },
              key: 'mdiSemaglutideB6Refill_dizzinessWhileTakingGlp1'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.chest_pain':
                  true
              },
              key: 'mdiSemaglutideB6Refill_chestPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.fevers':
                  true
              },
              key: 'mdiSemaglutideB6Refill_feverWhileTakingGlp1'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiSemaglutideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiSemaglutideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiSemaglutideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiSemaglutideB6Refill_constipation'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiSemaglutideB6Refill_heartburn'
            }
          ],
          els: 'mdiSemaglutideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiSemaglutideB6Refill_abdominalPainWhileTakingGlp',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.dizziness_that_concerns_me':
                  true
              },
              key: 'mdiSemaglutideB6Refill_dizzinessWhileTakingGlp1'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.chest_pain':
                  true
              },
              key: 'mdiSemaglutideB6Refill_chestPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.fevers':
                  true
              },
              key: 'mdiSemaglutideB6Refill_feverWhileTakingGlp1'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiSemaglutideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiSemaglutideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiSemaglutideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiSemaglutideB6Refill_constipation'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiSemaglutideB6Refill_heartburn'
            }
          ],
          els: 'mdiSemaglutideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiSemaglutideB6Refill_dizzinessWhileTakingGlp1',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.chest_pain':
                  true
              },
              key: 'mdiSemaglutideB6Refill_chestPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.fevers':
                  true
              },
              key: 'mdiSemaglutideB6Refill_feverWhileTakingGlp1'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiSemaglutideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiSemaglutideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiSemaglutideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiSemaglutideB6Refill_constipation'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiSemaglutideB6Refill_heartburn'
            }
          ],
          els: 'mdiSemaglutideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiSemaglutideB6Refill_chestPainWhileTakingGlp',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.fevers':
                  true
              },
              key: 'mdiSemaglutideB6Refill_feverWhileTakingGlp1'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiSemaglutideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiSemaglutideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiSemaglutideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiSemaglutideB6Refill_constipation'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiSemaglutideB6Refill_heartburn'
            }
          ],
          els: 'mdiSemaglutideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiSemaglutideB6Refill_feverWhileTakingGlp1',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiSemaglutideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiSemaglutideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiSemaglutideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiSemaglutideB6Refill_constipation'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiSemaglutideB6Refill_heartburn'
            }
          ],
          els: 'mdiSemaglutideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiSemaglutideB6Refill_swellingNeckWhileTakingGlp',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiSemaglutideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiSemaglutideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiSemaglutideB6Refill_constipation'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiSemaglutideB6Refill_heartburn'
            }
          ],
          els: 'mdiSemaglutideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiSemaglutideB6Refill_tellDoctorAboutSymptomsExperiencing',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiSemaglutideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiSemaglutideB6Refill_constipation'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiSemaglutideB6Refill_heartburn'
            }
          ],
          els: 'mdiSemaglutideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiSemaglutideB6Refill_nauseaMostCommonSideEffect',
        next: {
          switch: [
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiSemaglutideB6Refill_constipation'
            },
            {
              condition: {
                'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiSemaglutideB6Refill_heartburn'
            }
          ],
          els: 'mdiSemaglutideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiSemaglutideB6Refill_constipation',
        next: {
          condition: {
            'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
              true
          },
          key: 'mdiSemaglutideB6Refill_heartburn',
          els: 'mdiSemaglutideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      'mdiSemaglutideB6Refill_heartburn',
      'mdiSemaglutideB6Refill_readInformationAboutPersonalizedTreatment',
      'mdiSemaglutideB6Refill_wereDiscontinueCompoundedTreatmentSignificantly',
      'mdiSemaglutideB6Refill_nextPrescriptionThinkShould',
      'mdiSemaglutideB6Refill_importantClickAttachedLinkReview',
      'mdiSemaglutideB6Refill_messageDoctorGiveUpdateFeel',
      'mdiSemaglutideB6Refill_complete'
    ]
  };
